









import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("currency", {
      currencyName: "name",
      currencyRate: "rate",
    }),
  },
})
export default class ToggleCurrency extends Vue {
  private currencyName: string;
  private currencyRate: string;
}
